<template>
  <transition :css="false" :appear="false" @enter="enter" @leave="leave">
    <div onclick="window.dataLayer.push({'articleName': 'historia'})" class="RangeSlide">
      <div class="RangeSlide-container">
        <div class="RangeSlide-bg" :style="backgroundStyle" ref="background" />
        <div class="RangeSlide-fig">
          <img
            class="RangeSlide-image"
            ref="images"
            v-for="(img, index) in imagesData"
            :key="index"
            :src="img.src"
            :style="img.style"
          />
        </div>
        <div class="RangeSlide-info" ref="info">
          <h1 class="RangeSlide-h1">
            <span class="RangeSlide-yearLabel">
              AÑO
            </span>
            <span class="RangeSlide-year">
              {{ yearRange }}
            </span>
          </h1>
          <h2 class="RangeSlide-title" v-if="range.title">
            {{ range.title }}
          </h2>
          <p class="RangeSlide-description">
            {{ range.description }}
          </p>
        </div>
      </div>
      <div ref="pins">
        <RangePins :pins="range.pins" />
      </div>
    </div>
  </transition>
</template>

<script>
import * as images from "@/data/historyImages";
import gsap, { TweenMax } from "gsap";
import RangePins from "@/components/RangePins";

export default {
  props: {
    index: Number,
    range: Object,
    animDirection: {
      type: String,
      default: "left",
    },
  },
  components: {
    RangePins,
  },
  computed: {
    yearRange() {
      const [yearA, yearB] = this.range.yearRange;
      return `${yearA} - ${yearB}`;
    },
    imagesData() {
      const { index } = this;
      return this.range.figAssets.map(asset => {
        const paddedIndex = `${index}`.padStart(2, "0");
        const imageKey = `${paddedIndex}/${asset.id}`;
        return {
          src: images.slide[imageKey],
          style: asset.style,
        };
      });
    },
    backgroundStyle() {
      const { range } = this;
      const paddedIndex = `${this.index}`.padStart(2, "0");
      const imageKey = `${paddedIndex}/background`;

      let output = {
        "background-image": `url(${images.slide[imageKey]})`,
      };
      if (range.backgroundStyle) {
        output = {
          ...output,
          ...range.backgroundStyle,
        };
      }
      return output;
    },
  },
  methods: {
    enter(el, done) {
      if (window.innerWidth >= 1100) {
        this.desktopEnter(el, done);
      } else {
        this.mobileEnter(el, done);
      }
    },
    leave(el, done) {
      if (window.innerWidth >= 1100) {
        this.desktopLeave(el, done);
      } else {
        this.mobileLeave(el, done);
      }
    },
    mobileEnter(el, done) {
      const { animDirection, $refs, range } = this;
      const elems = [...$refs.images.reverse(), $refs.info, $refs.pins];

      gsap.fromTo(
        $refs.background,
        0.5,
        { alpha: 0 },
        {
          alpha: range.backgroundStyle?.opacity ?? 1,
          delay: 0.5,
          ease: "power1.out",
        },
      );

      gsap.fromTo(
        elems,
        0.5,
        {
          x: animDirection === "left" ? "15%" : "-15%",
          alpha: 0,
        },
        {
          x: 0,
          alpha: 1,
          delay: 0.5,
          stagger: 0.05,
          ease: "power3.out",
          onComplete: done,
        },
      );
    },
    mobileLeave(el, done) {
      const { animDirection, $refs } = this;
      const elems = [...$refs.images.reverse(), $refs.info, $refs.pins];

      gsap.to($refs.background, 0.5, {
        alpha: 0,
        ease: "power1.out",
      });

      gsap.set(el, { position: "absolute", top: 0, width: "100%" });
      TweenMax.to(elems, 0.5, {
        x: animDirection === "left" ? "-15%" : "15%",
        alpha: 0,
        stagger: 0.05,
        ease: "power3.inOut",
        onComplete: () => {
          gsap.set(el, { clearProps: "all" });
          done();
        },
      });
    },
    desktopEnter(el, done) {
      const { animDirection, $refs, range } = this;
      const elems = [$refs.info, ...$refs.images.reverse()];

      if (animDirection == "left") {
        elems.reverse();
      }

      gsap.fromTo(
        $refs.background,
        0.75,
        { alpha: 0 },
        {
          alpha: range.backgroundStyle?.opacity ?? 1,
          delay: 0.5,
          ease: "power1.out",
        },
      );

      gsap.fromTo(
        elems,
        0.75,
        {
          x: animDirection === "left" ? "15%" : "-15%",
          alpha: 0,
        },
        {
          x: 0,
          alpha: 1,
          delay: 1.1,
          stagger: 0.05,
          onComplete: done,
          ease: "power3.out",
        },
      );
    },
    desktopLeave(el, done) {
      const { animDirection, $refs } = this;
      const elems = [$refs.info, ...$refs.images.reverse()];

      if (animDirection == "right") {
        elems.reverse();
      }

      gsap.to($refs.background, 1, {
        alpha: 0,
        ease: "power1.out",
      });

      TweenMax.to(elems, 1, {
        x: animDirection === "left" ? "-15%" : "15%",
        alpha: 0,
        onComplete: done,
        stagger: 0.05,
        ease: "power3.inOut",
        delay: 0.1,
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './RangeSlide.styl';
</style>
